/* Mendwell — single-SKU buy-now flow.
   Intercepts product form submit. Clears cart, adds variant, redirects to /checkout.
   Leaves Shopify dynamic checkout buttons (Shop Pay, Apple Pay, Google Pay, iDEAL via Shop Pay) alone. */
(function () {
  'use strict';

  function isProductForm(form) {
    if (!form) return false;
    var action = (form.getAttribute('action') || '');
    if (action.indexOf('/cart/add') === -1) return false;
    // Skip dynamic-checkout payment-button forms (they don't have id input the same way)
    if (form.classList.contains('shopify-payment-button')) return false;
    return true;
  }

  function setBuying(btn, on) {
    if (!btn) return;
    btn.classList.toggle('mw-buying', on);
    btn.disabled = !!on;
  }

  function findButton(form) {
    return form.querySelector('button[type="submit"], input[type="submit"]');
  }

  async function buyNow(form) {
    var btn = findButton(form);
    setBuying(btn, true);
    try {
      // Always clear so single-SKU never accumulates
      await fetch('/cart/clear.js', {method: 'POST', headers: {'Accept':'application/json'}});

      var formData = new FormData(form);
      // Ensure quantity defaults to 1
      if (!formData.get('quantity')) formData.set('quantity', '1');

      var addRes = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest'},
        body: formData
      });

      if (!addRes.ok) {
        var err = await addRes.json().catch(function(){ return {description: 'Kon dit product niet toevoegen.'}; });
        throw new Error(err.description || err.message || 'Toevoegen mislukt');
      }

      // Optional: dispatch event so any listeners (analytics, micro-interactions) can react
      document.dispatchEvent(new CustomEvent('mendwell:buy-now', {detail: {form: form}}));

      window.location.href = '/checkout';
    } catch (e) {
      setBuying(btn, false);
      console.error('[mendwell] buy-now failed:', e);
      var msg = form.querySelector('[data-mw-buy-error]');
      if (msg) {
        msg.textContent = (e && e.message) || 'Er ging iets mis. Probeer het opnieuw.';
        msg.hidden = false;
      } else {
        alert((e && e.message) || 'Er ging iets mis. Probeer het opnieuw.');
      }
    }
  }

  function attach() {
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    forms.forEach(function (form) {
      if (form.dataset.mwBuyNow === '1') return;
      form.dataset.mwBuyNow = '1';
      if (!isProductForm(form)) return;

      // Travel ships its own AJAX-add handler that listens on the submit
      // button's CLICK event and prevents native form submission. Our
      // form-level submit listener never fires in that case. Solution:
      // intercept the click in capture phase BEFORE Travel's handler,
      // stop propagation, and run our buy-now flow.
      var btns = form.querySelectorAll('button[type="submit"], input[type="submit"]');
      btns.forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          // Skip dynamic-checkout payment buttons (Shop Pay, Apple Pay, etc.)
          if (e.target.closest('.shopify-payment-button')) return;
          e.preventDefault();
          e.stopImmediatePropagation();
          buyNow(form);
        }, true);
      });

      // Belt-and-suspenders: also catch native form submit if it slips through
      form.addEventListener('submit', function (e) {
        var submitter = e.submitter;
        if (submitter && submitter.closest('.shopify-payment-button')) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        buyNow(form);
      }, true);
    });

    // Sticky CTA: wire any [data-mw-buy-trigger] to submit the main product form
    var triggers = document.querySelectorAll('[data-mw-buy-trigger]:not([data-mw-wired])');
    triggers.forEach(function (t) {
      t.dataset.mwWired = '1';
      t.addEventListener('click', function (e) {
        e.preventDefault();
        var f = document.querySelector('form[action*="/cart/add"]:not([data-mw-disabled])');
        if (!f) return;
        // Use form.requestSubmit so submit handlers fire
        if (typeof f.requestSubmit === 'function') f.requestSubmit();
        else f.dispatchEvent(new Event('submit', {cancelable: true, bubbles: true}));
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attach);
  } else {
    attach();
  }
  // Re-run after Shopify section render (variant change, etc.)
  document.addEventListener('shopify:section:load', attach);
})();
